import { Injectable } from '@angular/core';
import { HeroCarouselIntl } from '@knorr-bremse-portals/ngx-components/components/hero/hero-carousel';


@Injectable({providedIn: 'root'})
export class LocalHeroCarouselIntl extends HeroCarouselIntl {

  public override previousPageButtonLabel = $localize `:hero carousel previous page button label@@3629960544875360046:Previous page`;
  public override nextPageButtonLabel = $localize `:hero carousel next page button label@@3337301694210287595:Next page`;

}
